import * as Sentry from "@sentry/react";

export type SentryLogLevel =
  | "trace"
  | "debug"
  | "info"
  | "warn"
  | "error"
  | "fatal";

/**
 * Single chokepoint for Sentry structured-log events. Guards the experimental
 * `Sentry.logger` API (and the test mock): no-ops if `logger` or the level fn
 * is absent, and swallows any throw so logging can never break the caller.
 */
export const logSentryEvent = (
  message: string,
  attributes?: Record<string, unknown>,
  level: SentryLogLevel = "info"
): void => {
  try {
    const logger = (
      Sentry as unknown as {
        logger?: Record<
          string,
          | ((message: string, attributes?: Record<string, unknown>) => void)
          | undefined
        >;
      }
    ).logger;
    logger?.[level]?.(message, attributes);
  } catch {
    // never let logging break the caller
  }
};
